import * as React from 'react';
import { IconMenuOrder } from '../../../../components/SvgIcons/IconMenuOrder';

const { READ_ONLY_FEATURES } = process.env;

/**
 * Function dynamically creates column action elements based off of type.
 * This allows a table config to simply use a "withActions" array argument
 * to control accessible action elements.
 * @param type
 * @param addEditHandle
 * @param deleteHandle
 * @returns {null|{icon: string, action: (function(): *), label: string}|{icon: string, action: (function(*=): *), label: string}}
 */
const createAction = (type, addEditHandle, deleteHandle, selectHandle, exportHandle, copyHandle) => {
    switch (type) {
        case 'copy':
            return {
                label: 'Copy',
                icon: 'content_copy',
                type: 'copy',
                disabled: READ_ONLY_FEATURES === 'true',
                action: (id) => copyHandle(id)
            };
        case 'create':
            return {
                label: 'Create',
                icon: 'post_add',
                type: 'create',
                disabled: READ_ONLY_FEATURES === 'true',
                action: () => addEditHandle('new')
            };
        case 'edit':
            return {
                label: 'Edit',
                type: 'edit',
                icon: 'edit',
                action: (id) => addEditHandle(id)
            };
        case 'export':
            return {
                label: 'Export',
                type: 'export',
                icon: 'file_download',
                iconProps: {
                    size: 28
                },
                action: (id) => exportHandle(id)
            };
        case 'view':
            return {
                label: 'View',
                type: 'view',
                icon: 'visibility',
                action: (id) => addEditHandle(id)
            };
        case 'delete':
            return {
                label: 'Delete',
                type: 'delete',
                icon: 'delete',
                disabled: READ_ONLY_FEATURES === 'true',
                action: (id) => deleteHandle(id)
            };
        case 'select':
            return {
                label: 'Select',
                type: 'select',
                icon: 'add',
                action: (id) => selectHandle(id)
            };
        case 'drag':
            return {
                label: 'Drag',
                type: 'drag',
                icon: <IconMenuOrder color="#3879af" />
            };
        default:
            return null;
    }
};

export default createAction;
